import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Fehlzeiten } from '../_models/fehlzeiten';
import { Statistik } from '../_models/statistik';
//import { Kursteilnehmer } from "./../_models/teilnehmer";
//import { TeilnehmerService } from "./teilnehmer.service";

@Injectable()
export class AnwesenheitService {
  
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    

  }

  getFehlzeitenByTn(tnid: number) {
    return this.http.get<Fehlzeiten[]>(this.baseUrl + "/api/fehlzeiten/GetFehlzeitenByTn/" + tnid);
  }

  GetAbsenceTimeSpanUnexcused(tnid: number) {
    return this.http.get<string>(this.baseUrl + "/api/fehlzeiten/GetAbsenceTimeSpanUnexcused/" + tnid);
  }

  getTnFehlzeitenHeute(tnid: number, datum?:string)
  {
    if (datum == undefined)
    {
      return this.http.get<Fehlzeiten[]>(this.baseUrl + "/api/fehlzeiten/getfehlzeitenheute/" + tnid);

    }
    else
    {
      return this.http.get<Fehlzeiten[]>(this.baseUrl + "/api/fehlzeiten/getfehlzeitenheute/" + tnid+"/"+datum);
    }
  }
  postNewTnFehlzeiten( data: Fehlzeiten)
  {
    return this.http.post<Fehlzeiten>(this.baseUrl + "/api/fehlzeiten", data);
  }
  postChangeTnFehlzeiten(data:Fehlzeiten)
  {
    return this.http.post<Fehlzeiten>(this.baseUrl + "/api/fehlzeiten/updatefehlzeit", data);
  }
  delete(data:Fehlzeiten)
  {
    return this.http.post<Fehlzeiten>(this.baseUrl + "/api/fehlzeiten/delete", data);
  }
  getUnentschuldigt(tnid)
  {
    return this.http.get<Fehlzeiten[]>(this.baseUrl + "/api/fehlzeiten/getunentschuldigt/" + tnid);
  }
  getStatistik()
  {
    return this.http.get<Statistik[]>(this.baseUrl + "/api/statistik");
  }
  getStatistikByTn(tnid: number) {
    return this.http.get<Statistik>(this.baseUrl + "/api/statistik/" + tnid);
  }
}





// WEBPACK FOOTER //
// ./src/app/_services/anwesenheit.service.ts